<div class="container single-view" id="view-product">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/products" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'PRODUCTS.BTN_BACK_TO_PRODUCT' | translate }}</a>
      </div>
      <div class="switch-wr">
        @if (allowModifyProduct) {
          <p-selectButton
            class="status-switch"
            [class.status-active]="stateInitialValue === true"
            [options]="stateOptions"
            optionLabel="displayLabel"
            optionValue="value"
            [allowEmpty]="false"
            [(ngModel)]="stateInitialValue"
            (onChange)="onStateChange($event)">
            <ng-template #item let-option>
              <span
                class="status-option"
                [attr.data-testid]="'btn-' + option.label">
                <i class="pi pi-check status-check" aria-hidden="true"></i>
                <span>{{ option.displayLabel }}</span>
              </span>
            </ng-template>
          </p-selectButton>
        }
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="product-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'PRODUCTS.VIEW_PRODUCT_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                <span data-testid='product-name'>{{ product.name | defaultValue }}</span>
                @if (product.isActive) {
                  <span data-testid='product-status' class="tag tag-green">{{ 'ENUMS.ACTIVE' | translate }}</span>
                }
                @if (!product.isActive) {
                  <span data-testid='product-status' class="tag tag-red">{{ 'ENUMS.INACTIVE' | translate }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex">
            <span data-testid='producttype' class="flex items-center mr-2 truncate" pTooltip="{{ 'PRODUCT_SINGLE_VIEW.TOOLTIP_PRODUCT_TYPE' | translate }}" tooltipPosition="top"><i class="icon icon-product-types mr-1"></i>{{ product.productType.name | defaultValue }}</span>
            <span data-testid='productcollection' class="flex items-center mr-2 truncate" pTooltip="{{ 'PRODUCT_SINGLE_VIEW.TOOLTIP_PRODUCT_COLLECTION' | translate }}" tooltipPosition="top"><i class="icon icon-collections mr-1"></i>{{ product.collections | defaultValue }}</span>
            <span data-testid='productcategory' class="flex items-center mr-2 truncate" pTooltip="{{ 'PRODUCT_SINGLE_VIEW.TOOLTIP_PRODUCT_CATEGORY' | translate }}" tooltipPosition="top"><i class="icon icon-category mr-1"></i>{{ product.categories | defaultValue }}</span>
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyProduct) {
              <button data-testid='product-edit-btn' id="btn-edit-product" class="btn primary-btn" (click)="goToEditProduct()">{{ 'PRODUCT_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='product-delete-btn' id="btn-delete-product" class="btn red-btn" (click)="showDeleteDialog()">{{'PRODUCTS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                <img data-testid='product-imageurl' src="{{ product.imageUrl }}" class="w-100 mt-2 featured-image">
              </div>
              <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                <h4 data-testid='product-details' >{{ 'PRODUCT_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  @if (brandsTotalRecords > 1 && !hasOnlyOneActiveBrand) {
                    <dt data-testid="product-brand-label" class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.BRAND' | translate }}</dt>
                    <dd data-testid="product-brand" class="value pt-3 pb-3">{{ product.brandName | defaultValue }}</dd>
                  }

                  <dt data-testid='product-description-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.SHORT_DESCRIPTION' | translate }}</dt>
                  <dd data-testid='product-description' class="value pt-3 pb-3">{{ product.description | defaultValue }}</dd>

                  @if (product.isLimitedEdition) {
                    <dt data-testid='product-sku-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.PRODUCT_REFERENCE_NUMBER' | translate }}</dt>
                    <dd data-testid='product-sku' class="value pt-3 pb-3">{{ product.sku | defaultValue }}</dd>
                    <dt data-testid='product-islimitededition-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.LIMITED_EDITION' | translate }}</dt>
                    <dd data-testid='product-islimitededition' class="value pt-3 pb-3">{{ product.isLimitedEdition | friendlyBoolean }}</dd>
                    <dt data-testid='product-limitededitionsize-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.TOTAL_EDITION_UNITS' | translate }}</dt>
                    <dd data-testid='product-limitededitionsize' class="value pt-3 pb-3">{{ product.limitedEditionSize | defaultValue }}</dd>
                  } @else {
                    <dt data-testid='product-sku-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.PRODUCT_SKU' | translate }}</dt>
                    <dd data-testid='product-sku' class="value pt-3 pb-3">{{ product.sku | defaultValue }}</dd>
                  }

                  @if (canViewPrice) {
                    <dt data-testid='product-price-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.PRICE' | translate }}</dt>
                  }
                  @if (canViewPrice) {
                    <dd data-testid='product-price' class="value pt-3 pb-3">{{ product.price | defaultValue }}</dd>
                  }

                  <dt data-testid='product-comment-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.COMMENTS' | translate }}</dt>
                  <dd data-testid='product-comment' class="value pt-3 pb-3">{{ product.comment | defaultValue }}</dd>

                  <dt data-testid='product-iscustomisable-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.CUSTOMIZABLE' | translate }}</dt>
                  <dd data-testid='product-iscustomisable' class="value pt-3 pb-3">{{ product.isCustomisable | friendlyBoolean }}</dd>

                  <dt data-testid='product-requireswarrantycard-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_SINGLE_VIEW.REQUIRES_SN' | translate }}</dt>
                  <dd data-testid='product-requires-sn-label' class="value pt-3 pb-3">{{ product.isSerialNumberRequired | friendlyBoolean
                  }}</dd>

                </dl>
              </div>

              @if (showProductAttributeDetails && translatedProductAttributes.length) {
                <div class="col-12 col-sm-12 mt-4">
                  <h4 data-testid='product-productattribute-details'>{{ 'PRODUCT_SINGLE_VIEW.PRODUCT_ATTRIBUTES' | translate }}</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                  <dl class="details-grid">
                    @for (attr of translatedProductAttributes; track attr) {
                      <dt class="label grid-cols-1 pt-3">
                        {{ attr.name | defaultValue }} @if (attr.changesOverTime) {
                        <i class="icon icon-clock ml-1"></i>
                      }
                    </dt>
                    <dd [attr.data-testid]="'product-productAttributes-' + (attr.code || 'unknown')"  class="value pt-3 pb-3">
                      {{ attr.value | defaultValue }}
                    </dd>
                  }
                </dl>
              </div>
            }

          </section>
          <!-- /main content -->
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Confirmation: state change -->
<p-confirmDialog key="confirm-state-change-dialog" (onHide)="stateInitialValue = product.isActive">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_CONFIRM_STATE_CHANGE' | translate }}</span>
  </ng-template>
  <ng-template pTemplate="message">
    <div class="flex flex-column align-items-center w-full gap-3">
      <p [innerHTML]="sanitizedConfirmMessage"></p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button data-testid='cancel-state-btn'  type="button" class="btn outline-btn" (click)="onCancelStateChange()">{{
    'MODALBOXES.BTN_CANCEL_STATE_UPDATE' | translate }}</button>
    <button data-testid='confirm-state-btn' type="button" class="btn primary-btn" (click)="onConfirmStateChange()">{{
    'MODALBOXES.BTN_CONFIRM_STATE_UPDATE' | translate }}</button>
  </ng-template>
</p-confirmDialog>

<!-- Delete product -->
<dialog-reason  #dialog [title]="'PRODUCTS.BTN_DELETE'" (onClose)="deleteProduct($event)"></dialog-reason>
